/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const questionDataSubtypeSchema = z.enum(['name', 'email', 'phone', 'multiple'])

export type QuestionDataSubtypeSchema = z.infer<typeof questionDataSubtypeSchema>
